import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import TabelaApontamentosMontagem from "./components/TabelaApontamentosMontagem";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import { Apontamento } from "./components/Types";
import TabelaApontamentosGeral from "./components/TabelaApontamentosGeral";

export default function HistoricoApontamentos(): JSX.Element {

    const CentroTrabalho = [
        '01CORTE', '01HIDCOR', '03SERIG', '05EMPOLV', '06CURVAD', '09IOX_E',
        '09IOX_S', '12PRDACO', '13PRE_IB', '14MONTAG', '15EMBOL',
        '16ACV', '18INSFIN', '57ENGENH', '57LABORA'
    ];
    const [centroTrabalhoSelect, setCentroTrabalhoSelect] = useState('');
    const [apontamentos, setApontamentos] = useState<Apontamento[]>([]);


    const handleApontamentos = async () => {
        setApontamentos([]);
        try {
            const { data } = await blogFetch.get('HistoricoApontamento/GetHistoricoApontamentos', { params: { CentroTrabalho: centroTrabalhoSelect } });

            if (data && data.length > 0) {
                setApontamentos(data);
            }
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {
        handleApontamentos();
    }, [centroTrabalhoSelect]);


    return (
        <div className="d-flex app_">
            <Sidebar />
            <Navbar />
            <div className="flex-grow-1">
                <div className="container-fluid mt-4 app_body">
                    <h3 className="fw-bold text-primary mb-4">Historico de Apontamentos</h3>


                    <div className="my-4 d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <h1 className="h4 mb-0 text-gray-800">
                            Centro de Trabalho:
                        </h1>

                        <select
                            className="form-select form-select-sm w-auto shadow-sm rounded"
                            value={centroTrabalhoSelect}
                            onChange={(e) => setCentroTrabalhoSelect(e.target.value)}
                        >
                            <option value="">Escolha um Centro</option>
                            {CentroTrabalho.map((centro) => (
                                <option key={centro} value={centro}>
                                    {centro}
                                </option>
                            ))}
                        </select>

                        {centroTrabalhoSelect == '14MONTAG' && (
                            <div className="container-fluid mt-4">
                                <TabelaApontamentosMontagem apontamentos={apontamentos} />
                            </div>
                        )}

                        {centroTrabalhoSelect !== "" && centroTrabalhoSelect !== "14MONTAG" && (
                            <div className="container-fluid mt-4">
                                <TabelaApontamentosGeral apontamentos={apontamentos} />
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>


    );
}
